import { render, staticRenderFns } from "./instrList.vue?vue&type=template&id=62572258&scoped=true&"
import script from "./instrList.vue?vue&type=script&lang=js&"
export * from "./instrList.vue?vue&type=script&lang=js&"
import style0 from "./instrList.vue?vue&type=style&index=0&id=62572258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62572258",
  null
  
)

export default component.exports